export default "__VITE_ASSET__BD7UCod6__"